// Algolia client credentials for every consumer of this bundle.
//
// These are public, client-side keys -- the search key is search/browse only and the insights key
// only writes events -- so they are safe to ship in the bundle. They are driven by MIX_ALGOLIA_*
// env vars so that rotating a key or pointing an environment at a different Algolia application is
// an env change rather than a hunt through call sites.
//
// Laravel Mix inlines MIX_-prefixed env vars at build time via webpack's DefinePlugin. There are
// deliberately no fallback values: a missing var is a misconfigured build, and a bundle that
// quietly carries hardcoded credentials is the thing we are trying to get away from. webpack.mix.js
// asserts these are present before compiling, so this throw is the backstop for a bundle built
// outside the normal pipeline.
function required(name, value) {
    if (typeof value !== 'string' || !value.trim()) {
        throw new Error(
            `${name} is not set. Algolia credentials are inlined at build time -- copy .env.example ` +
                'to .env for local builds, or pass the matching build arg in CI.',
        );
    }

    return value;
}

export const algoliaAppId = required('MIX_ALGOLIA_APP_ID', process.env.MIX_ALGOLIA_APP_ID);
export const algoliaSearchApiKey = required('MIX_ALGOLIA_SEARCH_API_KEY', process.env.MIX_ALGOLIA_SEARCH_API_KEY);
export const algoliaInsightsApiKey = required(
    'MIX_ALGOLIA_INSIGHTS_API_KEY',
    process.env.MIX_ALGOLIA_INSIGHTS_API_KEY,
);
